import { createApp } from "vue";

import Rooms from "./Rooms.vue";
import RoomCard from "@components/RoomCard.vue";
import Price from "@components/Price.vue";

const handle = "almero-vue-rooms";
const mountEls = document.querySelectorAll(`.${handle}`);

mountEls.forEach((mountEl) => {
    let props = {};
    try {
        props = JSON.parse(mountEl.dataset.rootProps);
    }
    catch (e) {
        console.error(e);
    }
    const app = createApp(
        Rooms, {
            ...props,
        }
    );

    app.component("RoomCard", RoomCard);
    app.component("Price", Price);

    app.mount(mountEl);
});